import Vue from 'vue';
import _ from 'lodash';

export default {
  state: {
    currencies: [],
  },
  getters: {
    currencies(state) {
      return state.currencies;
    },
    // eslint-disable-next-line
    currency: state => (id) => {
      return state.currencies.find(currency => currency.id === id) || {};
    },
    primaryCurrency(state) {
      const currency = _.orderBy(state.currencies, 'priority');
      return currency[0];
    },
  },
  mutations: {
    SET_CURRENCIES(state, payload) {
      state.currencies = payload;
    },
  },
  actions: {
    GET_CURRENCIES({ state, commit }) {
      if (state.currencies.length < 1) {
        return Vue.axios.get('filters/currencies').then(({ data }) => {
          commit('SET_CURRENCIES', data);
        });
      }
      return new Promise((resolve) => {
        resolve('ready');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/currencies.js